import type { ResponseFn } from './types'

export function excitatory(gain: number): ResponseFn {
  return (s: number) => gain * s
}

export function inhibitory(gain: number, baseline: number): ResponseFn {
  return (s: number) => Math.max(0, baseline - gain * s)
}

export function bellCurve(
  peak: number,
  width: number,
  maxOutput: number,
): ResponseFn {
  const denom = 2 * width * width
  return (s: number) => maxOutput * Math.exp(-((s - peak) ** 2) / denom)
}

export function threshold(cutoff: number, output: number): ResponseFn {
  return (s: number) => (s >= cutoff ? output : 0)
}
